// components/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-4xl font-bold text-red-500">404</h1>
      <p className="text-lg text-gray-700 mt-4">Page non trouvée</p>
      <Link
        to="/"
        className="mt-6 px-4 py-2 bg-primary text-white rounded hover:bg-blue-600"
      >
        Retour à l'accueil
      </Link>
    </div>
  );
};

export default NotFound;